module.exports = __webpack_public_path__ + "img/2-7-m-resort.9fdb60c1.jpg";